import OpenAI, { ClientOptions } from 'openai';
import AuthService from 'services/AuthService';
import { NIL_UUID } from 'v2/core/entities/uuid';
import { PROXY_OPENAI_URL } from '../constants';

type OpenAIClientOptions = Omit<
  ClientOptions,
  'baseURL' | 'apiKey' | 'dangerouslyAllowBrowser'
>;

let openAIInstance: OpenAI | null = null;

export const getOpenAILLM = (opts?: OpenAIClientOptions) => {
  if (openAIInstance) {
    return openAIInstance;
  }

  openAIInstance = new OpenAI({
    ...opts,
    baseURL: PROXY_OPENAI_URL,
    apiKey: NIL_UUID,
    dangerouslyAllowBrowser: true,
    defaultHeaders: {
      ...opts?.defaultHeaders,
      Authorization: `Bearer ${AuthService.getToken()}`,
      slug: AuthService.getTenantSlug(),
    },
  });

  return openAIInstance;
};
